.wrapper {
  bottom: var(--pgm-sys-spacing-6);
  position: fixed;
  right: var(--pgm-sys-spacing-6);
  z-index: 1000;
}

.floatingWhatsapp.floatingWhatsapp {
  --pgm-icon-button-size: 56px;
  --md-icon-button-icon-size: 24px;
  --md-icon-button-state-layer-shape: 16px;
  --md-filled-tonal-icon-button-container-color: var(--pgm-sys-color-secondary-fixed-dim);
  --md-filled-tonal-icon-button-icon-color: var(--pgm-sys-color-on-secondary-fixed);
  --md-filled-tonal-icon-button-hover-icon-color: var(--pgm-sys-color-on-secondary-fixed);
  --md-filled-tonal-icon-button-focus-icon-color: var(--pgm-sys-color-on-secondary-fixed);
  --md-filled-tonal-icon-button-pressed-icon-color: var(--pgm-sys-color-on-secondary-fixed);
  --md-filled-tonal-icon-button-container-shape: 16px;
  --md-filled-tonal-icon-button-hover-state-layer-color: var(--pgm-sys-color-on-secondary-fixed);
  --md-filled-tonal-icon-button-hover-state-layer-opacity: 0.08;
  --md-filled-tonal-icon-button-pressed-state-layer-color: var(--pgm-sys-color-on-secondary-fixed);
  --md-filled-tonal-icon-button-pressed-state-layer-opacity: 0.1;
  --md-focus-ring-color: var(--pgm-sys-color-secondary);
  --md-focus-ring-width: 3px;
  --md-focus-ring-outward-offset: 6px;

  border-radius: 16px;
  box-shadow: var(--pgm-sys-elevation-level3);
  transition: box-shadow 150ms cubic-bezier(0.2, 0, 0, 1);

  svg {
    display: block;
    height: 24px;
    width: 24px;
  }
}

.floatingWhatsapp.floatingWhatsapp:hover:not([disabled]):not([soft-disabled]) {
  --md-filled-tonal-icon-button-container-shape: 16px;
  --md-icon-button-state-layer-shape: 16px;

  box-shadow: var(--pgm-sys-elevation-level4);
}

.floatingWhatsapp.floatingWhatsapp:active:not([disabled]):not([soft-disabled]) {
  --md-filled-tonal-icon-button-container-shape: 12px;
  --md-icon-button-state-layer-shape: 12px;

  border-radius: 12px;
  box-shadow: var(--pgm-sys-elevation-level3);
}

@media (prefers-reduced-motion: reduce) {
  .floatingWhatsapp.floatingWhatsapp {
    transition: none;
  }
}
